import React from 'react'
import PropTypes from 'prop-types'

const WidgetIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6906 12.5594C17.975 13.4313 18.875 14.6125 18.875 16.1875V19H22.625V16.1875C22.625 14.1438 19.2781 12.9344 16.6906 12.5594Z"
        fill={color}
      />
      <path
        d="M15.125 11.5C17.1969 11.5 18.875 9.82188 18.875 7.75C18.875 5.67812 17.1969 4 15.125 4C14.6844 4 14.2719 4.09375 13.8781 4.225C14.6562 5.19062 15.125 6.41875 15.125 7.75C15.125 9.08125 14.6562 10.3094 13.8781 11.275C14.2719 11.4062 14.6844 11.5 15.125 11.5Z"
        fill={color}
      />
      <path
        d="M9.50003 11.5C11.5719 11.5 13.25 9.82188 13.25 7.75C13.25 5.67812 11.5719 4 9.50003 4C7.42816 4 5.75003 5.67812 5.75003 7.75C5.75003 9.82188 7.42816 11.5 9.50003 11.5ZM9.50003 5.875C10.5313 5.875 11.375 6.71875 11.375 7.75C11.375 8.78125 10.5313 9.625 9.50003 9.625C8.46878 9.625 7.62503 8.78125 7.62503 7.75C7.62503 6.71875 8.46878 5.875 9.50003 5.875Z"
        fill={color}
      />
      <path
        d="M9.5 12.4375C6.99687 12.4375 2 13.6938 2 16.1875V19H17V16.1875C17 13.6938 12.0031 12.4375 9.5 12.4375ZM15.125 17.125H3.875V16.1969C4.0625 15.5219 6.96875 14.3125 9.5 14.3125C12.0312 14.3125 14.9375 15.5219 15.125 16.1875V17.125Z"
        fill={color}
      />
    </svg>
  )
}

WidgetIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(WidgetIcon)
